var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.1667C2 24.3355 2.74628 22.5792 4.07466 21.2843C5.40304 19.9894 7.20472 19.262 9.08333 19.262H23.25C25.1286 19.262 26.9303 19.9894 28.2587 21.2843C29.5871 22.5792 30.3333 24.3355 30.3333 26.1667C30.3333 27.0824 29.9602 27.9605 29.296 28.6079C28.6318 29.2554 27.731 29.6191 26.7917 29.6191H5.54167C4.60236 29.6191 3.70152 29.2554 3.03733 28.6079C2.37314 27.9605 2 27.0824 2 26.1667Z",
    stroke: "#458898",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 12.3571C19.1005 12.3571 21.479 10.0386 21.479 7.17857C21.479 4.31853 19.1005 2 16.1665 2C13.2325 2 10.854 4.31853 10.854 7.17857C10.854 10.0386 13.2325 12.3571 16.1665 12.3571Z",
    stroke: "#458898",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAzul);
export default __webpack_public_path__ + "static/media/profileAzul.127a34413a76b48264e62e0157b155da.svg";
export { ForwardRef as ReactComponent };